export default __webpack_public_path__ + "static/media/img-0395-serbia-full-face.2f40031f.png";